import {
  IPagination,
  TBehavioralDataResponse,
  TGeneralInfo,
  TLifeIdState,
  TVitalDataResponse,
  TVitalDataSearchItems,
  TVitalSettingsResponse,
} from '../../types/life-id';
import { vitalDataDefaultSettings } from '../../helpers/vital-list-helper/defaultlRanges';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBehavioralTimelineData } from 'types/behavioral-data';

const initialState: TLifeIdState = {
  generalInfo: {
    id: null,
    createdAt: null,
    updatedAt: null,
    userId: null,
    deletedAt: null,
    bloodType: null,
    rhBloodType: null,
    height: null,
    weight: null,
    waistCircumference: null,
    smoker: null,
    BMI: null,
  },
  vitalData: null,
  behavioralData: null,
  behavioralDataTimeline: null,
  vitalListDataSettings: vitalDataDefaultSettings,
  items: [],
  searchPagination: { total: 0, pageSize: 20, current: 1, direction: 'ASC', sortBy: 'name' },
};

const lifeIdSlice = createSlice({
  name: 'lifeId',
  initialState,
  reducers: {
    getVitalDataRequest: (state, _: PayloadAction<{ providerId: string; id: string }>) => {
      state.getVitalDataRequestStatus = 'pending';
    },
    getVitalDataSuccess: (state, action: PayloadAction<TVitalDataResponse | null>) => {
      state.vitalData = action.payload;
      state.getVitalDataRequestStatus = 'success';
    },

    getBehavioralDataRequest: (state, _: PayloadAction<string>) => {
      state.getBehavioralDataRequestStatus = 'pending';
    },
    getBehavioralDataSuccess: (state, action: PayloadAction<TBehavioralDataResponse | null>) => {
      state.behavioralData = action.payload;
    },

    getBehavioralTimelineDataByIdRequest: (state, _: PayloadAction<any>) => {
      state.getBehavioralDataTimelineByIdRequestStatus = 'pending';
    },
    getBehavioralTimelineDataByIdSuccess: (
      state,
      action: PayloadAction<IBehavioralTimelineData | null>,
    ) => {
      state.behavioralDataTimeline = action.payload;
    },

    getGeneralInfoRequest: (state, _: PayloadAction<{ providerId: string; id: string }>) => {
      state.getGeneralInfoRequestStatus = 'pending';
    },
    getGeneralInfoSuccess: (state, action: PayloadAction<TGeneralInfo | null>) => {
      state.generalInfo = action.payload;
    },

    getVitalDataIntervalsRequest: (state, _: PayloadAction<{ providerId: string; id: string }>) => {
      state.getVitalDataIntervalsRequestStatus = 'pending';
    },
    getVitalDataIntervalsSuccess: (state, action: PayloadAction<TVitalSettingsResponse | null>) => {
      state.vitalListDataSettings = action.payload;
    },
    resetVitalItems: (state, _: PayloadAction) => {
      state.items = [];
      state.searchPagination = {
        total: 0,
        pageSize: 20,
        current: 1,
        sortBy: 'name',
        direction: 'ASC',
      };
    },
    getVitalDataItemsRequest: (state, _: PayloadAction<any>) => {
      state.getVitalDataItemsRequestStatus = 'pending';
    },
    getVitalDataItemsSuccess: (
      state,
      action: PayloadAction<{ pagination: IPagination; items: TVitalDataSearchItems }>,
    ) => {
      state.getVitalDataItemsRequestStatus = 'success';
      // @ts-ignore
      state.items = [...state.items, ...action.payload.items];
      state.searchPagination = action.payload.pagination;
    },
  },
});

export const { actions, name, reducer } = lifeIdSlice;
export default reducer;
